import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  Button,
  CircularProgress,
  IconButton
} from "@material-ui/core";
import { ExpandMore, DeleteForever } from "@material-ui/icons";
import React, { useState, useEffect, useRef } from 'react';
import NewTextEditor from "../../../../components/Admin/NewTextEditor";
import { producaov2 } from "../../../../services/apis";
import { toast } from 'react-toastify';

const optionQuestionMapper = {
  1: "Discordo totalmente",
  2: "Discordo parcialmente",
  3: "Não concordo nem discordo",
  4: "Concordo Parcialmente",
  5: "Concordo Totalmente",
};

const optionQuestionMapperCompetency = {
  1: "Nenhuma experiencia",
  2: "Conhecimento Básico",
  3: "Conhecimento Intermediário",
  4: "Conhecimento Avançado",
  5: "Especialista",
};

export default function QuestionAndAnswersModal({
  open,
  selectedMapeamento,
  onClose,
  onAiPepUpdated,
  onAiPepDeleted,
}) {
  const aiPepDescriptionRef = useRef(""); 
  const [initialAiPepDescription, setInitialAiPepDescription] = useState('');
  const [isSavingAiPep, setIsSavingAiPep] = useState(false);
  const [isDeletingAiPep, setIsDeletingAiPep] = useState(false);

  useEffect(() => {
    if (open && selectedMapeamento?.ai_pep && Array.isArray(selectedMapeamento.ai_pep) && selectedMapeamento.ai_pep.length > 0 && typeof selectedMapeamento.ai_pep[0]?.description === 'string') {
      const currentDescription = selectedMapeamento.ai_pep[0].description;
      setInitialAiPepDescription(currentDescription);
      aiPepDescriptionRef.current = currentDescription; 
    } else if (open) {
      setInitialAiPepDescription('');
      aiPepDescriptionRef.current = '';
    }
  }, [selectedMapeamento, open]);

  const handleSaveAiPepSuggestion = async () => {
    if (!selectedMapeamento || !selectedMapeamento.id) {
      console.error("ID do mapeamento não encontrado para salvar a sugestão da IA.");
      return;
    }
    if (!aiPepDescriptionRef.current.trim()) {
      console.error('A sugestão da IA não pode estar vazia.');
      return;
    }

    setIsSavingAiPep(true);
    try {
      await producaov2.put(`/pep/ai/${selectedMapeamento?.ai_pep[0].id}`, {
        description: aiPepDescriptionRef.current,
      });

      toast.success('Resposta atualizada com sucesso');
            if (onAiPepUpdated) {
        onAiPepUpdated();
      }
    } catch (error) {
      console.error('Erro ao salvar sugestão da IA:', error);
    } finally {
      setIsSavingAiPep(false);
    }
  };

  const handleDeleteAiPepSuggestion = async () => {
    if (!selectedMapeamento?.ai_pep || !selectedMapeamento.ai_pep[0]?.id) {
      toast.error("ID da sugestão da IA não encontrado para exclusão.");
      return;
    }

    setIsDeletingAiPep(true);
    try {
      await producaov2.delete(`/pep/ai/${selectedMapeamento.ai_pep[0].id}`);
      
      toast.success('Sugestão da IA excluída com sucesso!');
      setInitialAiPepDescription('');
      aiPepDescriptionRef.current = ''; 
      if (onAiPepDeleted) {
        onAiPepDeleted();
      }
    } catch (error) {
      console.error('Erro ao excluir sugestão da IA:', error);
      toast.error('Erro ao excluir sugestão da IA. Tente novamente.');
    } finally {
      setIsDeletingAiPep(false);
    }
  };  

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
      <DialogTitle>Perguntas e Respostas</DialogTitle>
      <DialogContent>
        {selectedMapeamento?.ai_pep && 
         Array.isArray(selectedMapeamento.ai_pep) && 
         selectedMapeamento.ai_pep.length > 0 && 
         selectedMapeamento.ai_pep[0]?.description && (
          <Accordion TransitionProps={{ unmountOnExit: true }} defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              style={{ width: '100%' }} 
            >
              <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                <Typography variant="h6">Sugestão Gerada pela IA</Typography>
                <IconButton 
                  aria-label="delete suggestion" 
                  onClick={(event) => {
                    event.stopPropagation(); // Impede que o clique no botão expanda/recolha o accordion
                    handleDeleteAiPepSuggestion();
                  }}
                  disabled={isDeletingAiPep || isSavingAiPep} // Desabilita se estiver salvando ou deletando
                  size="small" // Para um tamanho menor, se desejado
                >
                  {isDeletingAiPep ? <CircularProgress size={20} color="inherit" /> : <DeleteForever color="error" />}
                </IconButton>
              </Box>
            </AccordionSummary>
            <AccordionDetails style={{ flexDirection: 'column' }}>
              <NewTextEditor
                haveFullscreen
                default={initialAiPepDescription} 
                text={aiPepDescriptionRef}
              />
              <Box mt={2} display="flex" justifyContent="flex-end">
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={handleSaveAiPepSuggestion}
                  disabled={isSavingAiPep}
                >
                  {isSavingAiPep ? <CircularProgress size={24} color="inherit" /> : "Salvar Sugestão"}
                </Button>
              </Box>
            </AccordionDetails>
          </Accordion>
        )}

        {selectedMapeamento?.ai_pep && 
         Array.isArray(selectedMapeamento.ai_pep) && 
         selectedMapeamento.ai_pep.length > 0 && 
         selectedMapeamento.ai_pep[0]?.description && 
         selectedMapeamento?.responses?.length > 0 && (
          <Divider style={{ margin: '16px 0' }} />
        )}

        {selectedMapeamento?.responses?.map((answer, index) => {
          if (!answer) {
            return null; 
          }

          const subQuestions = answer.subquestions?.includes(",")
            ? answer.subquestions?.split(",")
            : answer.subquestions;
          
          let subQuestionsAnswers = [];
          if (typeof answer.answer === 'string') {
            subQuestionsAnswers = answer.answer.split(",");
          } else if (Array.isArray(answer.answer)) {
            subQuestionsAnswers = answer.answer;
          } else if (answer.answer !== undefined && answer.answer !== null) {
            subQuestionsAnswers = [String(answer.answer)];
          }


          return (
            <Accordion key={answer.id_question || `answer-${index}`} TransitionProps={{ unmountOnExit: true }}>
              <AccordionSummary
                expandIcon={<ExpandMore />}
              >{`${answer.id_question} - ${answer.question_text}`}</AccordionSummary>
              <AccordionDetails>
                {!subQuestions && <Typography>{answer.answer}</Typography>}
                {subQuestions && Array.isArray(subQuestions) && (
                  <Box
                    display="flex"
                    flexDirection="column"
                    gridRowGap="0.75rem"
                    width="100%"
                  >
                    {subQuestions.map((question, subIndex) => {
                      const answerOption = subQuestionsAnswers[subIndex];
                      
                      const questionTypeMapper = answer.id_question !== 6 
                        ? optionQuestionMapper 
                        : optionQuestionMapperCompetency;
                      
                      const answerText = (answerOption !== undefined && questionTypeMapper[answerOption])
                        ? `${questionTypeMapper[answerOption]} - ${answerOption}`
                        : "Sem Resposta";

                      return (
                        <React.Fragment key={subIndex}> 
                          {subIndex > 0 && <Divider />}
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            width="100%"
                          >
                            <Typography>{question}</Typography>
                            <Typography>
                              <strong>
                                {answerText}
                              </strong>
                            </Typography>
                          </Box>
                        </React.Fragment>
                      );
                    })}
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </DialogContent>
    </Dialog>
  );
}
